import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  midWidth: {
    width: 320,
  },
  error: {
    color: theme.palette.error.main,
    fontSize: '0.75rem',
    margin: '0 14px',
  },
  containerTextField: {
    display: 'flex',
    flexDirection: 'column',
    '& .field-check': {
      opacity: 0,
      color: theme.palette.success.main,
    },
    '&.field-updated': {
      '& fieldset': {
        borderColor: theme.palette.success.main,
      },
      '& label': {
        color: theme.palette.success.main,
      },
      '& .field-check': {
        opacity: 1,
        paddingRight: 8,
      },
    },
  },
  grey: {
    color: theme.palette.secondary.dark,
  },
  startIcon: {
    marginRight: 0,
    color: theme.palette.text.primary,
  },
  colorPreview: {
    width: 24,
    height: 24,
    borderRadius: 4,
  },
}))
